module.exports = __webpack_public_path__ + "static/media/bgtop-system-01-1.5a3614c3.jpg";